// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"bef2d8c3","333":"80d914a0","845":"29fa313c","884":"68f4e362"}[chunkId] + ".chunk.js";
};